(() => {
  'use strict';

  const money = (cents) => {
    const value = cents / 100;
    const rounded = Math.round(value * 100) / 100;
    const text = rounded % 1 === 0 ? String(rounded) : rounded.toFixed(2);
    return '€' + text;
  };

  function initRail(rail) {
    rail.querySelectorAll('[data-rail-toggle]').forEach((el) => {
      el.addEventListener('click', () => {
        const open = rail.dataset.rail !== 'closed';
        rail.dataset.rail = open ? 'closed' : 'open';
        const btn = rail.querySelector('.railtoggle');
        if (btn) btn.textContent = open ? '›' : '‹';
      });
    });
  }

  // Size/Frame don't filter the grid — per the design they re-price each card by finding the
  // matching variant. Falls back to "from <min price>" whenever the selection has no match.
  function initPriceFacets(root) {
    const selection = { size: '', frame: '' };

    function repriceCards() {
      root.querySelectorAll('[data-variant-card]').forEach((card) => {
        const dataEl = card.querySelector('[data-variant-prices]');
        const priceEl = card.querySelector('[data-card-price]');
        if (!dataEl || !priceEl) return;

        let variants;
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (_) {
          return;
        }

        // Cards stay on "from <min>" until a size is picked — frame alone doesn't pin down a
        // single price, matching the design's behaviour.
        const wanted = [selection.size, selection.frame].filter(Boolean);
        let match = null;
        if (selection.size) {
          match = variants.find((v) => wanted.every((w) => v.options.includes(w)));
        }

        if (match) {
          priceEl.textContent = money(match.price);
        } else {
          const min = Number(priceEl.dataset.priceMin || 0);
          priceEl.textContent = 'from ' + money(min);
        }
      });
    }

    root.querySelectorAll('[data-price-facet]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const facet = btn.dataset.priceFacet;
        const value = btn.dataset.value || '';
        selection[facet] = value;
        root
          .querySelectorAll(`[data-price-facet="${facet}"]`)
          .forEach((sibling) => sibling.setAttribute('data-on', sibling === btn ? 'true' : 'false'));
        repriceCards();
      });
    });

    // Seed from whatever is marked active on load (frame defaults to its first value).
    root.querySelectorAll('[data-price-facet][data-on="true"]').forEach((btn) => {
      selection[btn.dataset.priceFacet] = btn.dataset.value || '';
    });
    repriceCards();
  }

  // Custom sort dropdown. A native <select> was the only control on the page rendering in OS
  // chrome, so this is a button + listbox pair; each option is a real <a href> so sorting
  // still works if this script fails and middle-click/open-in-new-tab behave normally.
  function initSort(root) {
    const trigger = root.querySelector('[data-sort-trigger]');
    const menu = root.querySelector('[data-sort-menu]');
    if (!trigger || !menu) return;

    const options = Array.from(menu.querySelectorAll('[data-sort-option]'));

    const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';

    function open() {
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      const selected = menu.querySelector('[aria-selected="true"]') || options[0];
      if (selected) selected.focus();
    }

    function close({ refocus = false } = {}) {
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      if (refocus) trigger.focus();
    }

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      isOpen() ? close() : open();
    });

    // Roving focus through the list; Home/End jump to the ends.
    menu.addEventListener('keydown', (event) => {
      const index = options.indexOf(document.activeElement);
      let next = null;
      if (event.key === 'ArrowDown') next = options[Math.min(index + 1, options.length - 1)];
      else if (event.key === 'ArrowUp') next = options[Math.max(index - 1, 0)];
      else if (event.key === 'Home') next = options[0];
      else if (event.key === 'End') next = options[options.length - 1];
      else if (event.key === 'Escape') {
        close({ refocus: true });
        return;
      } else return;

      event.preventDefault();
      if (next) next.focus();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
      }
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !root.contains(event.target)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) close({ refocus: true });
    });
  }

  // The filter <details> ships `open` so desktop and no-JS phones keep today's layout.
  // Below the rail's breakpoint the whole thing stacks above the grid, so collapse it —
  // otherwise the first product sits about 1.6 screens down behind a wall of filters.
  // Only the initial state is touched; once the visitor opens it, it stays their choice.
  function initFilterCollapse(details) {
    const narrow = window.matchMedia('(max-width: 900px)');
    let touched = false;
    // Setting `.open` fires `toggle` just like a click does, so without this guard the very
    // first programmatic collapse would mark the panel as user-touched and freeze it.
    let programmatic = false;

    details.addEventListener('toggle', () => {
      if (!programmatic) touched = true;
    });

    const apply = () => {
      if (touched) return;
      const next = !narrow.matches;
      if (details.open === next) return;
      programmatic = true;
      details.open = next;
      programmatic = false;
    };

    apply();
    narrow.addEventListener('change', apply);
  }

  document.querySelectorAll('[data-rail-filters]').forEach(initFilterCollapse);
  document.querySelectorAll('[data-meningea-rail]').forEach(initRail);
  document.querySelectorAll('.meningea-coll').forEach(initPriceFacets);
  document.querySelectorAll('[data-sort]').forEach(initSort);
})();
